import React, { useState } from "react";
import PropTypes from "prop-types";
import { CreateIntercomContextProvider } from "./context";

export const IntercomProvider = ({ children }) => {
  const [isIntercomStarted, setIsIntercomStarted] = useState(false);

  return (
    <CreateIntercomContextProvider
      value={{
        isIntercomStarted,
        setIsIntercomStarted,
      }}
    >
      {children}
    </CreateIntercomContextProvider>
  );
};

IntercomProvider.propTypes = {
  children: PropTypes.any,
};
